export default __webpack_public_path__ + "static/media/Rerebrace of the Blood Drinker (nm).621a9089.jpg";